import http from "./http";
import {useRequest} from "ahooks";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import useNotice from "../hooks/useNotice";
import { useNavigateTo } from "../hooks/useNavigateTo";

let apiPath = {
  sendCodeEmail: '/sys/userPass/sendCodeEmail',
  // sendCodeEmail: '/tiny-shop/v1/site/sms-code',
  forgetPassword: '/sys/userPass/forgetPassword'
};

export const useSendCodeEmail = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.sendCodeEmail,
      method: 'post',
      data: q || {}
    });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    sendCode: runAsync
  };
};

export const useForgetPassword = () => {
  const notice = useNotice();
  const navigateTo = useNavigateTo();
  const { t } = useTranslation();
  const [query, setQuery] = useState({
    mobileno: '',
    password: '',
    verifyCode: '',
    confirmPwd: '',
  });
  
  const { data, runAsync, error, loading } = useRequest((q) => {
    let obj = {
      mobileno: q.account,
      password: q.pwd,
      verifyCode: q.verifyCode,
    };
    
    return http({
      url: apiPath.forgetPassword,
      method: 'post',
      data: obj || {}
    });
  }, {
    manual: true,
  });
  
  const inputHandle = (e, name) => {
    let res = { ...query };
    res[name] = e.target.value;
    setQuery(res);
  };
  
  const forgetPwdHandle = async (onSuccess) => {
    let { data } = await runAsync(query);
    if (data) {
      notice.success(t('修改成功'));
      onSuccess();
      navigateTo('/login');
    }
  };
  
  return {
    result: data || {},
    loading,
    error,
    query,
    forgetPwd: forgetPwdHandle,
    inputHandle
  };
};
